import { useState, useRef, useMemo, useContext } from "react"
import SideBarStyled from "./SideBar.styled"
import { LinkIconStyled } from "theme/common/Link.styled"
import HeaderDefault from "components/Theme/Header/Header"
import HeaderWom from "overrides/theme/wom/base/components/Theme/Header/Header"
import { IconArrowLeft, IconClose } from "theme/common/Icon.styled"
import NavigationMenu from "components/Theme/Sidebar/Navigation/NavigationMenu"
import SupportSection from "components/Theme/Sidebar/Support/SupportSection"
import useOnClickOutside from "hooks/useOnClickOutside"
import useLogin from "hooks/UseLogin"
import UseGetMenuUser from "hooks/UseGetMenuUser"
import Env from "classes/Env"
import { useEnv } from "hooks"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"
import { ResourceRoleEnum } from "enums/ResourceRoleEnum"
import useUserPermissions from "hooks/UseUserPermissions"
import { IMenu } from "interfaces/IMenu"
import { AuthContext } from "context/context/AuthContext"

const SideBar = () => {
  const [sidebar, setSidebar] = useState(false)
  const refElement = useRef<HTMLDivElement>(null)

  const [client] = useEnv().multiclient.get_user_env()

  const { getMenuSideBar } = UseGetMenuUser()

  const _menu = getMenuSideBar()

  // Obtener información del usuario desde el contexto
  const { state: { user } } = useContext(AuthContext)

  useOnClickOutside({ refElement, handleAction: () => setSidebar(false) })

  const { logout } = useLogin()

  const showSidebar = () => setSidebar(!sidebar)

  const signOut = () => logout()

  const Header = client !== Env.theme.wom.id ? HeaderDefault : HeaderWom

  const { permission } = useUserPermissions({ resources: [ResourcePermissionsEnum.createTROrder, ResourcePermissionsEnum.shippingGroup, ResourcePermissionsEnum.viewOrderSearch, ResourcePermissionsEnum.viewTeamPerformanceMetric] });

  // Función para crear menú específico del contractor-source
  const getContractorSourceMenu = (): IMenu[] => {
    return [
      {
        title: "Inicio",
        path: "/contractor/dashboard",
      },
      {
        title: "Bandeja de Recepción",
        path: "/contractor/reception",
      },
      {
        title: "Bandeja de Instalación",
        path: "/contractor/installation",
      },
    ]
  }

  // Usar useMemo para construir el menú basado en rol y permisos
  const menu = useMemo(() => {
    // Si el usuario es contractor-source, usar menú específico
    if (user?.role === ResourceRoleEnum["webapp-contractor-source"]) {
      return getContractorSourceMenu()
    }

    // Para otros roles, usar la lógica original
    const addMenu: IMenu[] = [..._menu]

    // Configuración de elementos adicionales basados en permisos
    const additionalMenuItems: Array<{ permission: boolean; item: IMenu }> = [
      {
        permission: permission[ResourcePermissionsEnum.createTROrder],
        item: {
          title: "Transferencia",
          path: "/page/transfer",
        }
      },
      {
        permission: permission[ResourcePermissionsEnum.shippingGroup],
        item: {
          title: "Consultar Manifiestos",
          path: "/page/manifest",
        }
      },
      {
        permission: permission[ResourcePermissionsEnum.viewOrderSearch],
        item: {
          title: "Consulta de Órdenes",
          path: "/view/orders",
        }
      },
      {
        permission: permission[ResourcePermissionsEnum.viewTeamPerformanceMetric],
        item: {
          title: "Performance de Equipo",
          path: "/view/team-performance-metric",
        }
      }
    ]

    // Agregar elementos adicionales si tienen permisos y no existen duplicados
    additionalMenuItems.forEach(({ permission: hasPermission, item }) => {
      if (hasPermission) {
        const itemExists = addMenu.some((menuItem: IMenu) => menuItem.title === item.title)
        if (!itemExists) {
          addMenu.push(item)
        }
      }
    })

    return addMenu
  }, [permission, _menu, user?.role])

  return (
    <>
      <Header onShowSidebar={showSidebar} />

      <SideBarStyled sidebar={sidebar} ref={refElement}>
        <div className="sidebar-wraper">
          <div className="header-sidebar">
            <LinkIconStyled to="#" onClick={showSidebar}>
              <IconArrowLeft />
              <span>Cerrar</span>
            </LinkIconStyled>
          </div>
          <section className="option-side-bar">
            {menu?.map((item, index) => (
              <NavigationMenu menu={item} toggleMenu={showSidebar} key={`${item.title}-${item.path}-${index}`} />
            ))}
          </section>
          <hr />
          <SupportSection />
          <div className="content-sign-out">
            <LinkIconStyled to="#" onClick={signOut}>
              <IconClose />
              <span>SALIR DE OMNIX</span>
            </LinkIconStyled>
          </div>
        </div>
      </SideBarStyled>
    </>
  )
}

export default SideBar
